import { IErrorResponseSchema } from '../../../repositories/chats/entities/schemas/ErrorResponseSchema';
import { EFirstMessageResponseStatus, TFirstMessageResponse } from '../types';

export const map400Response = (response: IErrorResponseSchema): TFirstMessageResponse => {
  const { message } = response;

  switch (message) {
    case 'needCaptcha': {
      return { status: EFirstMessageResponseStatus.NeedCaptcha };
    }

    case 'needConfirmPhone': {
      return { status: EFirstMessageResponseStatus.NeedConfirmPhone };
    }

    case 'userChatsDisabled': {
      return { status: EFirstMessageResponseStatus.UserChatsDisabled };
    }

    case 'validationError': {
      return { status: EFirstMessageResponseStatus.ValidationError, data: response };
    }

    default: {
      return { status: EFirstMessageResponseStatus.UnknownError, data: response };
    }
  }
};
